<div class="settings-dialog">

  <!-- Header -->
  <header class="dialog-header">

    <mat-icon class="header-icon">
      settings
    </mat-icon>

    <div class="header-content">

      <div class="dialog-title">
        {{ 'site_settings' | transloco }}
      </div>

      <div class="dialog-subtitle">
        {{ data.site.name }}
      </div>

    </div>

    <button
      mat-icon-button
      class="close-button"
      [matTooltip]="'close' | transloco"
      (click)="close()">

      <mat-icon>close</mat-icon>

    </button>

  </header>


  <!-- Main layout -->
  <div class="dialog-body">

    <!-- Navigation -->
    <nav class="settings-navigation">

      <div class="navigation-label">
        {{ 'site_settings' | transloco }}
      </div>


      @if (canManageNotifications) {

        <button
          class="navigation-item"
          [class.active]="selectedSection === 'notifications'"
          (click)="selectSection('notifications')">

          <mat-icon>
            notifications
          </mat-icon>

          <span>
            {{ 'settings_notifications' | transloco }}
          </span>

        </button>

      }

    </nav>


    <!-- Settings content -->
    <main class="settings-content">

      @switch (selectedSection) {

        @case ('notifications') {

          <section class="settings-section">

            <!-- Section heading -->
            <header class="section-header">

              <h2>
                {{ 'settings_notifications' | transloco }}
              </h2>

              <p>
                {{ 'settings_notifications_description' | transloco }}
              </p>

            </header>


            <!-- Advanced features -->
            <div class="settings-group">

              <div class="settings-group-title">
                {{ 'advanced_features' | transloco }}
              </div>


              <!-- Email notifications -->
              <div class="setting-row">

                <mat-icon class="setting-icon">
                  mail
                </mat-icon>


                <div class="setting-content">

                  <div class="setting-title">
                    {{
                      'advanced_feature_notification_emails'
                        | transloco
                    }}
                  </div>

                  <div class="setting-description">
                    {{
                      'advanced_feature_notification_emails_description'
                        | transloco
                    }}
                  </div>

                </div>


                @if ((userSettings$ | async); as settings) {

                  <mat-slide-toggle
                    [checked]="settings.advancedFeaturesEmailNotifications"
                    [disabled]="(userSettingsUpdating$ | async) === true"
                    (change)="onNotificationEmailsChange($event.checked)">
                  </mat-slide-toggle>

                }

              </div>

            </div>

          </section>

        }

      }

    </main>

  </div>

</div>
